module.exports = __webpack_public_path__ + "img/jieshu (1).4c656fd2.png";